import { all } from "redux-saga/effects";
import transactionSagas from "./transaction";
import priceSagas from "./price";

export default function* rootSaga() {
  yield all([...transactionSagas, ...priceSagas]);
}
